<script>
  import l from "../scripts/utilities.js";
  let { item } = $props();

  function makeFileLink(i) {
  let out =i.title;
  let link = null;
    if (i.hasOwnProperty("file") && i.file != null) {
      let file = i.file;
      console.log(file)
      link = file.url;
    }
    if (i.hasOwnProperty("external_link") && i.external_link !== "") {
      link = i.external_link;
    }
    if (link) {
      out = `<a href='${link}' target='_blank'>${i.title}</a>`;
    }
    return out;
  }

</script>

<li class="item">
  <span class="col-1 date">{item.date}</span>
  <div class="col-2 content">
    {#if item.suptitle}<span class='sup-title'>{item.suptitle}</span>{/if}
    <span class="title">{@html makeFileLink(item)}</span>
    <div class="summary">{@html item.summary}</div>
  </div>

</li>